import React from 'react';
import { motion } from 'framer-motion';
import { comparison, premiumModules } from '../data/premium';
export function PremiumSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="premium-title" data-id="element-186" data-mp="3cn7fn7oc9y96">
      <div className="mx-auto max-w-5xl px-4" data-id="element-187" data-mp="37stespqwqyx4">
        <div className="text-center" data-id="element-188" data-mp="32vkv2kq42mtr">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-189" data-mp="32ui5cg4iyqff">La diferencia premium</p>
          <h2 id="premium-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-190" data-mp="2xxrrlzg706x6">¿Qué agrega el Upsell Premium?</h2>
        </div>

        <div className="mt-10 overflow-x-auto pb-3" data-id="element-191" data-mp="2ovied1tjhzg3">
          <div className="min-w-[700px]" data-id="element-192" data-mp="2ow1zerehl3yc">
            <div className="grid grid-cols-3 gap-4 px-4 text-xs font-extrabold uppercase tracking-wider" data-id="element-193" data-mp="2jwfdltklefdx">
              <p className="text-muted" data-id="element-194" data-mp="n3wzasmu30cj">Situación</p>
              <p className="text-muted" data-id="element-195" data-mp="n3nbnbp9h5a0">Sin Upsell Premium</p>
              <p className="text-alert" data-id="element-196" data-mp="i4sro6fk5aob">Con Upsell Premium</p>
            </div>
            <div className="mt-3 space-y-2" data-id="element-197" data-mp="1bmqd76mkx605">
              {comparison.map(([situation, without, withPremium]) => <div key={situation} className="grid grid-cols-3 gap-4 rounded-xl border border-line bg-white p-4 text-sm" data-id="element-198" data-mp="1fobwb9ppigis">
                  <p className="font-bold text-ink" data-id="element-199" data-mp="11plwvnff04r9">{situation}</p>
                  <p className="text-muted" data-id="element-200" data-mp="16mvmb32t0gf3">{without}</p>
                  <p className="rounded-lg border border-teal/20 bg-aquaSoft p-2 font-semibold text-teal" data-id="element-201" data-mp="16phtv2pp2vxb">{withPremium}</p>
                </div>)}
            </div>
          </div>
        </div>
        <p className="mt-1 text-center text-xs text-muted md:hidden" data-id="element-202" data-mp="1zdvrhhcvfq8c">Deslizá para ver la tabla completa</p>

        <div className="mt-12 rounded-3xl border border-line bg-white p-6 shadow-card sm:p-10" data-id="element-203" data-mp="1klc01dz3376q">
          <h3 className="text-2xl font-bold text-ink" data-id="element-204" data-mp="1pjwtmujtysm7">¿Qué incluye el Upsell Premium?</h3>
          <div className="mt-7 grid gap-5 md:grid-cols-2" data-id="element-205" data-mp="2d9r79ebz4l7i">
            {premiumModules.map(([title, description, Icon], index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl border border-line bg-mist p-6" data-id="element-206" data-mp="2rz2jdu7z442z" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-aquaSoft text-teal" data-id="element-207" data-mp="28zon35mruh9b">
                  <Icon className="h-5 w-5" data-id="element-208" data-mp="24985raftybho" />
                </span>
                <h4 className="mt-4 text-lg font-bold text-ink" data-id="element-209" data-mp="246vkooerzl0e">{title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-210" data-mp="1zaes9i0jmkhi">{description}</p>
              </motion.article>)}
          </div>
        </div>
      </div>
    </section>;
}